export default function getReCaptchaApiKey() {
    return process.env.REACT_APP_RECAPTCHA_API_KEY;
}
